import { Component, Input, OnInit } from '@angular/core';
import { AbstractControl } from '@angular/forms';

@Component({
  selector: 'libero-text-input',
  templateUrl: './text-input.component.html',
  styleUrls: ['./text-input.component.scss'],
  standalone: false
})
export class TextInputComponent implements OnInit {
  @Input() public formName!: AbstractControl;
  @Input() public placeholder?: string;
  @Input() public invalidText?: string;

  public currentInputValue?: string;
  private isComposing = false;

  public setValueFromControl(): void {
    if(this.formName.value) {
      this.currentInputValue = this.formName.value;
    }
  }

  public ngOnInit(): void {
    this.setValueFromControl();
  }

  public onCompositionStart(): void {
    this.isComposing = true;
  }

  public onCompositionEnd(event: CompositionEvent): void {
    this.isComposing = false;
    this.formName.patchValue((event.target as HTMLInputElement).value);
  }

  public textInputUpdated(): void {
    if (!this.isComposing) {
      this.formName.patchValue(this.currentInputValue);
      this.formName.markAsTouched();
      this.formName.markAsDirty();
    }
  }
}
